import { useController, type Control, type FieldPath, type FieldValues } from "react-hook-form";
import { useTranslation } from "react-i18next";
import SearchIcon from "@assets/icons/search.svg?raw&inline";

interface SearchInputProps<TFieldValues extends FieldValues = FieldValues> {
  name: FieldPath<TFieldValues>;
  control: Control<TFieldValues>;
  placeholder?: string;
  disabled?: boolean;
  rules?: Parameters<typeof useController<TFieldValues>>[0]["rules"];
  className?: string;
  onSearch?: () => void;
}

export default function SearchInput<TFieldValues extends FieldValues = FieldValues>({
  name,
  control,
  placeholder,
  disabled,
  rules,
  className = "",
  onSearch,
}: SearchInputProps<TFieldValues>) {
  const { t } = useTranslation();
  const {
    field,
    fieldState: { error },
  } = useController<TFieldValues>({
    name,
    control,
    rules,
  });

  return (
    <div className={className}>
      <div className="d-flex gap-2 mb-2">
        <input
          {...field}
          id={name}
          type="text"
          className={`form-control less-rounded ${error ? "is-invalid" : ""}`}
          placeholder={placeholder}
          disabled={disabled}
        />
        <button
          type="submit"
          className="btn btn-black"
          style={{ minWidth: "49px" }}
          disabled={disabled}
          onClick={onSearch}
        >
          <span
            dangerouslySetInnerHTML={{ 
              __html: SearchIcon.replace(
                /<svg([^>]*)>/,
                '<svg$1 style="width: 19px; height: 19px;">'
              ),
              }} 
          />
        </button>
      </div>
      {error && (
        <div className="invalid-feedback d-block mb-2">
          {error.message ? t(error.message) : ""}
        </div>
      )}
    </div>
  );
}

